import { uniqueId } from 'lodash'
import {
  Tbody,
  Thead,
  TheadRow,
  TbodyRow,
  TbodyCell,
  TheadCell,
  TableWrapper,
  TableChecklist as Table,
  Signatories
} from './settlement.styled'
import { ConvertLocalTimeGet } from '../../utils'

const TallySheetModalContent = ({ dataPrint, dataSr }) => {
  return (
    <TableWrapper>
      <Table>
        <Thead>
          <TheadRow>
            <TheadCell rowSpan={2} width='4%'>
              No
            </TheadCell>
            <TheadCell rowSpan={2} width='auto'>
              Material
            </TheadCell>
            <TheadCell rowSpan={2} width='15%'>
              Unit ID Number
            </TheadCell>
            <TheadCell rowSpan={2} width='15%'>
              Person in Charge
            </TheadCell>
            <TheadCell rowSpan={2} width='15%'>
              Quantity Loading (Ton)
            </TheadCell>
            <TheadCell align='center' colSpan={2} width='8%'>
              Time
            </TheadCell>
            <TheadCell rowSpan={2} width='15%'>
              Keterangan
            </TheadCell>
          </TheadRow>
          <TheadRow>
            <TheadCell width='8%'>Start</TheadCell>
            <TheadCell width='8%'>Finish</TheadCell>
          </TheadRow>
        </Thead>
        <Tbody>
          {dataPrint?.tallySheet?.map((item, index) => (
            <TbodyRow key={index}>
              <TbodyCell>{index + 1}</TbodyCell>
              <TbodyCell>{item.product_name}</TbodyCell>
              <TbodyCell>{item.vehicle_number}</TbodyCell>
              <TbodyCell>{item.driver_name}</TbodyCell>
              <TbodyCell>{item.quantity}</TbodyCell>
              <TbodyCell>{item.start_date}</TbodyCell>
              <TbodyCell>{item.end_date}</TbodyCell>
              <TbodyCell>{item.remarks}</TbodyCell>
            </TbodyRow>
          ))}
        </Tbody>
      </Table>
      <Table>
        <thead>
          <TheadRow>
            <TheadCell width='40%'>Approver Name</TheadCell>
            <TheadCell width='60%'>Signatories</TheadCell>
          </TheadRow>
        </thead>
        <tbody>
          {dataPrint.Settlement_Approval?.map((item) => (
            <TbodyRow key={uniqueId('approval-')}>
              <TbodyCell>{item?.Confirmer_Name}</TbodyCell>
              <TbodyCell>
                <Signatories>
                  <span>Digital Signed By {item?.Confirmer_Name}</span>
                  <span>
                    Date :
                    {ConvertLocalTimeGet(
                      dataSr?.Location,
                      item?.Confirmer_Date,
                      'DD-MM-YYYY HH:mm'
                    )}
                  </span>
                </Signatories>
              </TbodyCell>
            </TbodyRow>
          ))}
        </tbody>
      </Table>
    </TableWrapper>
  )
}

export default TallySheetModalContent
